import React from "react";
import { Typography } from "@material-ui/core";
import TextEditor from "@icarius-common/textEditor";
import { previewFromURL } from "@icarius-utils/download";
import { RESOURCES_ENDPOINT } from "@icarius-connection/endpoints";
import { GetAppIcon } from "@icarius-icons/index";
import { getLocalizedString } from "@icarius-localization/strings";
import Container from "@icarius-pages/myTraining/components/container";

const ExerciseResolution = ({ resolution }) => {

  if (!resolution.answer && !resolution.file) return null;

  return (
    <Container
      title={getLocalizedString("resolution")}
      style={{ width: "100%" }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
        }}
      >
        {
          Boolean(resolution.answer) &&
          <div style={{ width: "100%" }}>
            <TextEditor
              disabled
              initialValue={resolution.answer}
            />
          </div>
        }
        {
          Boolean(resolution.file) &&
          <div
            onClick={() => previewFromURL(RESOURCES_ENDPOINT + resolution.file.path)}
          >
            <Typography
              variant="caption"
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                display: "flex",
                gap: 5,
                alignItems: "center",
              }}
            >
              <GetAppIcon fontSize="small" /> {resolution.file.name}
            </Typography>
          </div>
        }
      </div>
    </Container>
  );
}

export default ExerciseResolution;